<template>
	<el-dialog
		:visible.sync="isShow"
		width="12.15rem"
		id='WLDW_dialog'
		:show-close='true'
		:lock-scroll='false'
	>	
		<div class='ZJ_dialog_title' slot='title'>
			<span>往来单位明细</span>	
			<span>*账面明细记录由会计的记账而产生，仅供参</span>	
		</div>
		<div class='ZJ_dialog_form'>
			<el-form :inline="true" :model="form">
				<el-form-item>
					<el-select v-model='form.subjectId' placeholder='请选择' size='mini' filterable style='width: 140px' @change='handleSelectC_c'>
						<el-option v-for='item in tree_wldwData' :value='item.id' :label='item.name' :key='item.id'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label='排序:'>
					<el-select v-model='form.sort' placeholder='请选择' size='mini' filterable  style='width: 140px' @change='handleSelectC_c'>
						<el-option v-for='item in sort_wldwDate' :value='item.sort' :label='item.name' :key='item.sort'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-date-picker
				      v-model="date.yearPeriodsStart"
				      type="date"
				      size='mini'
				      style='width:140px;'
				      @change='handleSelectC_c_s'
				      placeholder="选择日期">
				    </el-date-picker>
				    至
				    <el-date-picker
				      v-model="date.yearPeriodsEnd"
				      type="date"
				      style='width:140px;'
				      size='mini'
				      @change='handleSelectC_c'
				     :picker-options='disAbleEnd'
				      placeholder="选择日期">
				    </el-date-picker>
				</el-form-item>
				<el-form-item label='账龄：' v-if='disabled_zl'>
					<el-input size='mini' style='width: .6rem;'  v-model='form.startAge' placeholder='开始'></el-input> 个月 - <el-input placeholder='结束' size='mini' style='width: .6rem;'  v-model='form.endAge' ></el-input> 个月
				</el-form-item>
				<el-form-item>
					<el-button size='mini' type='primary' @click='getAccountDetailedData'>搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class='JCZ_item'>
			<ul class='JCZ_item_ul'>
				<li class='JCZ_item_li active'>
					总额    {{theSum}}
				</li>
			</ul>
			<public-table :table="tableData" @onHandlePaginationChange="handlePaginationChange"></public-table>
		</div>
	</el-dialog>
</template>
<script>
	import publicTable from '@/components/publicTable'
	import {currencys} from '@/assets/utils/currencyFormat'
	export default {
		props: {
			showVisibles: Boolean,
			nowTypeID1: String,
			yearPeriod: String,
			period_date_start: Number,
			period_date_end: Number,
			disabled_zl: Boolean,
		},
		components: {
			publicTable,
		},
		data() {
			return {
				disAbleEnd:{
					disabledDate:(time)=>{
						let standard = this.date.yearPeriodsStart;
						if(standard) {
							return time.getTime()<standard;
						}
					}
				},
				date:{
					yearPeriodsStart: '',
					yearPeriodsEnd: '',
				},  
				sort_wldwDate: [],       // 排序
				tree_wldwData: [],  // 科目列表
				form:{
					endAge:'',       // 结束账龄
					startAge:'',   // 开始账龄
					sort: '',      // 排序
					subjectId: '',   // 科目ID
					startTime:'',
					endTime:'',
					currentPage: 1,   //当前页
					maxResult: 10,   //最大显示数据
				},          // 筛选条件
				JCXlist:[
					{name: '总额' ,id: 11 , money: 146584  },
				],
				nowID: 11,
				theSum: 0,           // 总额
				tableData: {
					border: true,				// 是否带有纵向边框
					isNotSuspensionShow: true,  // 不显示悬浮效果
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [{
						label: '初始日期',
						value: 'time',
						show: 'normal'
					},{
						label: '项目名称',
						value: 'name',
						show: 'normal'
					},{
						label: '账龄（年）',
						value: 'accountAge',
						show: 'normal'
					},{
						label: '剩余金额(元)',
						value: 'remaining_sum',
						show: 'normal'
					}],
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					operation: {
						label: '操作',
						value: 'operation',
						width: 160,
						data: [
						{
							label:"编辑",
							value:'editBtn'
						},{
							label:"删除",
							value:'delete'
						}]
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					}
				},

			}
		},
		created() {
		},
		computed: {
			// 显示弹窗
			isShow: {
				get () {
					return this.showVisibles;
				},
				set (val) {
					this.$emit('update:showVisibles', val);
				}
			},
		},
		methods: {
			// 时间联动
			handleSelectC_c_s() {
				let month = this.date.yearPeriodsStart.getMonth()+1;
				let year = this.date.yearPeriodsStart.getFullYear();
				let oneDay = 1000*60*60*24;
				let nextMonth;
				
				if(month==12) {
					nextMonth = (year+1)+'/'+"1";
				}else {
					nextMonth = year+'/'+(month+1);
				}
				this.date.yearPeriodsEnd = new Date(nextMonth).getTime()-oneDay;
				this.getAccountDetailedData();
			},
			// 下拉框、时间改变
			handleSelectC_c(){
				this.getAccountDetailedData();
			},
			// 翻页
			handlePaginationChange (data) {
				const { pageNo, pageSize } = data;

				if (pageNo) { 
					this.$set(this.form, 'currentPage', pageNo);
					this.$set(this.tableData.page, 'pageNo', pageNo);
				}

				if (pageSize) {
					this.$set(this.form, 'maxResult', pageSize);
					this.$set(this.tableData.page, 'pageSize', pageSize);
				}
				this.getAccountDetailedData();
			},
			// 获取往来单位详细数据_获取筛选条件
			getSort_wldw() {
				let _=this;
				try {
					_.$http.post('AccountCurrent/getSort',{}).then(res=>{
						if(res&&res.data.code==1) {
							_.sort_wldwDate = res.data.data;
							_.form.sort =  res.data.data[0].sort;
						}
					})
				}catch(e) {

				}
			},
			// 获取往来单位详细数据_获取科目POST /AccountCurrent/getTree
			getTree_wldw() {
				let _=this;
				try {
					_.$http.post('AccountCurrent/getTree',{}).then(res=>{
						if(res&&res.data.code==1) {
							_.tree_wldwData = res.data.data;
							_.form.subjectId = _.nowTypeID1;
							_.form.period = _.yearPeriod;
							_.getAccountDetailedData();
						}
					})
				}catch(e) {

				}
			},
			// 获取表格数据/AccountCurrent/accountDetailed
			getAccountDetailedData() {
				let _=this;
				if(_.form.startAge!==''&&!Number(_.form.startAge)){
					return this.$message.warning('开始账龄只能为空或者数字！')
				}
				if(_.form.endAge!==''&&!Number(_.form.endAge)){
					return this.$message.warning('结束账龄只能为空或者数字！')
				}
				if((_.form.startAge>_.form.endAge)&&_.form.startAge!==''&&_.form.endAge!=='') {
					return this.$message.warning('账龄开始不能大于结束哟！')
				}
				try {
					_.tableData.loading = true;
					_.form.startTime = _.$util.formatDate.format(_.date.yearPeriodsStart , 'yyyy-MM-dd');
				 	_.form.endTime = _.$util.formatDate.format(_.date.yearPeriodsEnd , 'yyyy-MM-dd');
					_.$http.post('AccountCurrent/accountDetailed',_.form).then(res=>{
						if(res&&res.data.code==1) {
							_.theSum = res.data.data.theSum?currencys(res.data.data.theSum):0;
							_.tableData.data = res.data.data.list.map(i=>{
								i.remaining_sum = currencys(i.remaining_sum);
								return i;
							});
							_.tableData.page=Object.assign(_.tableData.page,{
								pageNo: res.data.data.currentPage,
								pageSize: res.data.data.maxResult,
								count: res.data.data.total
							})
							_.tableData.loading = false;
							if(res.data.data.list.length) {
								_.tableData.hasShowPagination = true;

							}else {
								_.tableData.hasShowPagination = false;
							}
						}
					})
				}catch(e) {
					_.tableData.loading = false;
				}
			},
			
		},
		watch: {
			showVisibles(val) {
				if(val) {
					if(this.disabled_zl) {
						this.tableData.config.forEach(item=>{
							if(item.value == 'accountAge') {
								item.show = 'normal';
							}
						})
					}else {
						this.tableData.config.forEach(item=>{
							if(item.value == 'accountAge') {
								item.show = false;
							}
						})
					}
					this.date.yearPeriodsStart = this.period_date_start;
					this.date.yearPeriodsEnd = this.period_date_end;
					this.getSort_wldw();
					this.getTree_wldw();
				}
			}
		}
	}
</script>
<style lang='less'>
	#WLDW_dialog {
		.el-dialog__header {
			padding: .3rem .3rem 0;
		}
		.el-dialog__body {
			padding: .2rem 0rem .3rem;
		}
		.el-form--inline .el-form-item {
			margin-right: .2rem;
		}
		.el-form {
			padding: 0 .3rem .3rem;
			border-bottom: 1px solid #EEEEEE;
		}
		.el-form-item {
			margin-bottom:0;
		}
		.Lately_date {
			margin-left: .1rem;
			span {
				display: inline-block;
				margin: 0 .15rem;
				cursor: pointer;
				&:last-child{
					i{
						margin-left:.1rem;
					}
				};
			}
		}
		.ZJ_dialog_title {
			span {
				&:first-child {
					font-size:.16rem;
					color:#333;
					font-weight: bold;
				};
				&:last-child {
					font-size: .12rem;
					color: #ACB7C3;
				};
			}
		}
		.JCZ_item {
			padding: 0rem .3rem;

			.JCZ_item_ul {
				padding: .2rem 0rem;
				.active {
					background: #107EF2;
					
				}
				.JCZ_item_li{
					cursor: pointer;
					padding: 0 .25rem 0 .1rem;
					height: .4rem;
					font-size: .14rem;
					line-height: .4rem;
					text-align: center;
					display: inline-block;
					border: 1px solid #E3E3E3;
					border-radius: 5px;
					color: #fff;
					
				}
				
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/dialog/WldwDialog.vue